import React from 'react';
import { Icon } from './icon';
import { PShell } from '../layout-shell';

/** Enquanto `workspaceReady` é falso: evita flash da rota empty / lista vazia antes dos dados. */
function SpWorkspaceLoading({ active = 'dashboard', title = 'A carregar o seu espaço de trabalho…' }) {
  return (
    <PShell active={active}>
      <div className="sp-workspace-loading">
        <div className="sp-workspace-loading__icon" aria-hidden>
          <Icon name="grid" size={26} stroke={1.6} />
        </div>
        <div className="sp-workspace-loading__spinner" aria-hidden />
        <div className="sp-workspace-loading__title">{title}</div>
        <div className="sp-workspace-loading__hint">A sincronizar com o servidor</div>
      </div>
    </PShell>
  );
}

export { SpWorkspaceLoading };
